/* eslint-disable no-param-reassign */
import Fetch, { V1, V2, V3, serializeQueryString } from 'Util/fetcher';

const ON_REQUEST_REFERRAL_TRACKER = 'ON_REQUEST_REFERRAL_TRACKER';
const ON_REQUEST_REFERRAL_TRACKER_FAILURE = 'ON_REQUEST_REFERRAL_TRACKER_FAILURE';
const ON_REQUEST_REFERRAL_TRACKER_SUCCESS = 'ON_REQUEST_REFERRAL_TRACKER_SUCCESS';

function onRequestReferralTracker(resetData) {
  return {
    type: ON_REQUEST_REFERRAL_TRACKER,
    meta: { resetData },
  };
}

function onRequestReferralTrackerSuccess(payload) {
  return {
    type: ON_REQUEST_REFERRAL_TRACKER_SUCCESS,
    payload,
  };
}

function onRequestReferralTrackerFailure(payload) {
  return {
    type: ON_REQUEST_REFERRAL_TRACKER_FAILURE,
    payload,
  };
}

export const onDoRequestReferralTracker = (
  payload,
  resetData = false,
  isNext = false
) => (dispatch) => {
  dispatch(onRequestReferralTracker(resetData));
  const url = isNext ? payload : `${V3}users/referral-tracker/${payload}`;
  Fetch.get(url)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralTrackerSuccess(resp.json));
      } else {
        dispatch(onRequestReferralTrackerFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralTrackerFailure(error.message));
    });
};

const ON_REQUEST_REFERRAL_SEND_REMINDER = 'ON_REQUEST_REFERRAL_SEND_REMINDER';
const ON_REQUEST_REFERRAL_SEND_REMINDER_FAILURE = 'ON_REQUEST_REFERRAL_SEND_REMINDER_FAILURE';
const ON_REQUEST_REFERRAL_SEND_REMINDER_SUCCESS = 'ON_REQUEST_REFERRAL_SEND_REMINDER_SUCCESS';
function onRequestReferralSendReminder(id) {
  return {
    type: ON_REQUEST_REFERRAL_SEND_REMINDER,
    meta: { id },
  };
}
function onRequestReferralSendReminderSuccess(payload, id) {
  return {
    type: ON_REQUEST_REFERRAL_SEND_REMINDER_SUCCESS,
    payload,
    meta: { id },
  };
}
function onRequestReferralSendReminderFailure(payload, id) {
  return {
    type: ON_REQUEST_REFERRAL_SEND_REMINDER_FAILURE,
    payload,
    meta: { id },
  };
}
export const onDoRequestReferralSendReminder = id => (dispatch) => {
  dispatch(onRequestReferralSendReminder(id));
  Fetch.post(`${V2}users/referral-tracker/remind/`, id)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralSendReminderSuccess(resp.json.result, id));
      } else {
        dispatch(onRequestReferralSendReminderFailure(resp.json, id));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralSendReminderFailure(error.message, id));
    });
};

const ON_REQUEST_REFERRAL_BONUS_INFO = 'ON_REQUEST_REFERRAL_BONUS_INFO';
const ON_REQUEST_REFERRAL_BONUS_INFO_FAILURE = 'ON_REQUEST_REFERRAL_BONUS_INFO_FAILURE';
const ON_REQUEST_REFERRAL_BONUS_INFO_SUCCESS = 'ON_REQUEST_REFERRAL_BONUS_INFO_SUCCESS';
function onRequestReferralBonusInfo() {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_INFO,
  };
}
function onRequestReferralBonusInfoSuccess(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_INFO_SUCCESS,
    payload,
  };
}
function onRequestReferralBonusInfoFailure(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_INFO_FAILURE,
    payload,
  };
}
export const onDoRequestReferralBonusInfo = () => (dispatch) => {
  dispatch(onRequestReferralBonusInfo());
  Fetch.get(`${V1}transactions/bonuses/bonus-info/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralBonusInfoSuccess(resp.json));
      } else {
        dispatch(onRequestReferralBonusInfoFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralBonusInfoFailure(error.message));
    });
};

const ON_REQUEST_REFERRAL_BONUS_TRANSACTION = 'ON_REQUEST_REFERRAL_BONUS_TRANSACTION';
const ON_REQUEST_REFERRAL_BONUS_TRANSACTION_FAILURE = 'ON_REQUEST_REFERRAL_BONUS_TRANSACTION_FAILURE';
const ON_REQUEST_REFERRAL_BONUS_TRANSACTION_SUCCESS = 'ON_REQUEST_REFERRAL_BONUS_TRANSACTION_SUCCESS';
function onRequestReferralBonusTransaction() {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_TRANSACTION,
  };
}
function onRequestReferralBonusTransactionSuccess(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_TRANSACTION_SUCCESS,
    payload,
  };
}
function onRequestReferralBonusTransactionFailure(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_TRANSACTION_FAILURE,
    payload,
  };
}
export const onDoResetReferralBonusTransaction = () => (dispatch) => {
  dispatch(onRequestReferralBonusTransactionSuccess(null));
};
// bonusType = '' for MF and free fee. "/free-stock" for stock.
// payload empty for MF and stock, claim_type: 'FREE_FEE' for free fee
export const onDoRequestReferralBonusTransaction = (payload = {}, bonusType = '') => (dispatch) => {
  dispatch(onRequestReferralBonusTransaction());
  Fetch.post(`${V2}transactions/bonuses${bonusType}/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralBonusTransactionSuccess(resp.json.result));
      } else {
        dispatch(onRequestReferralBonusTransactionFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralBonusTransactionFailure(error.message));
    });
};

const ON_REQUEST_REFERRAL_BONUS_LIST_MF = 'ON_REQUEST_REFERRAL_BONUS_LIST_MF';
const ON_REQUEST_REFERRAL_BONUS_LIST_MF_FAILURE = 'ON_REQUEST_REFERRAL_BONUS_LIST_MF_FAILURE';
const ON_REQUEST_REFERRAL_BONUS_LIST_MF_SUCCESS = 'ON_REQUEST_REFERRAL_BONUS_LIST_MF_SUCCESS';
function onRequestReferralBonusListMF() {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_MF,
  };
}
function onRequestReferralBonusListMFSuccess(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_MF_SUCCESS,
    payload,
  };
}
function onRequestReferralBonusListMFFailure(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_MF_FAILURE,
    payload,
  };
}
export const onDoRequestReferralBonusListMF = () => (dispatch) => {
  dispatch(onRequestReferralBonusListMF());
  Fetch.get(`${V1}transactions/bonuses/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralBonusListMFSuccess(resp.json));
      } else {
        dispatch(onRequestReferralBonusListMFFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralBonusListMFFailure(error.message));
    });
};

const ON_REQUEST_REFERRAL_BONUS_LIST_STOCK = 'ON_REQUEST_REFERRAL_BONUS_LIST_STOCK';
const ON_REQUEST_REFERRAL_BONUS_LIST_STOCK_FAILURE = 'ON_REQUEST_REFERRAL_BONUS_LIST_STOCK_FAILURE';
const ON_REQUEST_REFERRAL_BONUS_LIST_STOCK_SUCCESS = 'ON_REQUEST_REFERRAL_BONUS_LIST_STOCK_SUCCESS';
function onRequestReferralBonusListStock(resetData) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_STOCK,
    meta: { resetData },
  };
}
function onRequestReferralBonusListStockSuccess(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_STOCK_SUCCESS,
    payload,
  };
}
function onRequestReferralBonusListStockFailure(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_STOCK_FAILURE,
    payload,
  };
}
export const onDoRequestReferralBonusListStock = (payload, resetData) => (dispatch) => {
  dispatch(onRequestReferralBonusListStock(resetData));
  const qs = serializeQueryString(payload);
  Fetch.get(`${V1}stock/bonus/log/${qs}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralBonusListStockSuccess(resp.json));
      } else {
        dispatch(onRequestReferralBonusListStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralBonusListStockFailure(error.message));
    });
};

const ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE = 'ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE';
const ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE_FAILURE = 'ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE_FAILURE';
const ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE_SUCCESS = 'ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE_SUCCESS';
function onRequestReferralBonusListFreeFee() {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE,
  };
}
function onRequestReferralBonusListFreeFeeSuccess(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE_SUCCESS,
    payload,
  };
}
function onRequestReferralBonusListFreeFeeFailure(payload) {
  return {
    type: ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE_FAILURE,
    payload,
  };
}
export const onDoRequestReferralBonusListFreeFee = () => (dispatch) => {
  dispatch(onRequestReferralBonusListFreeFee());
  Fetch.get(`${V1}transactions/bonuses/free-fee/history`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralBonusListFreeFeeSuccess(resp.json));
      } else {
        dispatch(onRequestReferralBonusListFreeFeeFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralBonusListFreeFeeFailure(error.message));
    });
};

const ON_REQUEST_REFERRAL_LINK = 'ON_REQUEST_REFERRAL_LINK';
const ON_REQUEST_REFERRAL_LINK_FAILURE = 'ON_REQUEST_REFERRAL_LINK_FAILURE';
const ON_REQUEST_REFERRAL_LINK_SUCCESS = 'ON_REQUEST_REFERRAL_LINK_SUCCESS';

function onRequestReferralLink() {
  return {
    type: ON_REQUEST_REFERRAL_LINK,
  };
}
function onRequestReferralLinkSuccess(payload) {
  return {
    type: ON_REQUEST_REFERRAL_LINK_SUCCESS,
    payload,
  };
}
function onRequestReferralLinkFailure(payload) {
  return {
    type: ON_REQUEST_REFERRAL_LINK_FAILURE,
    payload,
  };
}
export const onDoRequestReferralLink = (payload, param) => (dispatch) => {
  dispatch(onRequestReferralLink());
  Fetch.post(`https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${payload}`, param)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralLinkSuccess(resp.json));
      } else {
        dispatch(onRequestReferralLinkFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralLinkFailure(error.message));
    });
};

const ON_REQUEST_BONUS_STOCK_SUMMARY = 'ON_REQUEST_BONUS_STOCK_SUMMARY';
const ON_REQUEST_BONUS_STOCK_SUMMARY_SUCCESS = 'ON_REQUEST_BONUS_STOCK_SUMMARY_SUCCESS';
const ON_REQUEST_BONUS_STOCK_SUMMARY_FAILURE = 'ON_REQUEST_BONUS_STOCK_SUMMARY_FAILURE';

function onRequestBonusStockSum() {
  return {
    type: ON_REQUEST_BONUS_STOCK_SUMMARY,
  };
}

function onRequestBonusStockSumSuccess(payload) {
  return {
    type: ON_REQUEST_BONUS_STOCK_SUMMARY_SUCCESS,
    payload,
  };
}

function onRequestBonusStockSumFailure(payload) {
  return {
    type: ON_REQUEST_BONUS_STOCK_SUMMARY_FAILURE,
    payload,
  };
}

export const onDoRequestBonusStockSum = () => (dispatch) => {
  dispatch(onRequestBonusStockSum());
  Fetch.get(`${V1}transactions/bonuses/summary/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestBonusStockSumSuccess(resp.json));
      } else {
        dispatch(onRequestBonusStockSumFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestBonusStockSumFailure(error.message));
    });
};

const ON_REQUEST_REFERRAL_COIN_TRACK = 'ON_REQUEST_REFERRAL_COIN_TRACK';
const ON_REQUEST_REFERRAL_COIN_TRACK_SUCCESS = 'ON_REQUEST_REFERRAL_COIN_TRACK_SUCCESS';
const ON_REQUEST_REFERRAL_COIN_TRACK_FAILURE = 'ON_REQUEST_REFERRAL_COIN_TRACK_FAILURE';

function onRequestReferralCoinTrack() {
  return {
    type: ON_REQUEST_REFERRAL_COIN_TRACK,
  };
}

function onRequestReferralCoinTrackSuccess(payload) {
  return {
    type: ON_REQUEST_REFERRAL_COIN_TRACK_SUCCESS,
    payload,
  };
}

function onRequestReferralCoinTrackFailure(payload) {
  return {
    type: ON_REQUEST_REFERRAL_COIN_TRACK_FAILURE,
    payload,
  };
}

export const onDoRequestReferralCoinTrack = () => (dispatch) => {
  dispatch(onRequestReferralCoinTrack());
  Fetch.get(`${V1}transactions/bonuses/referred-coin/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestReferralCoinTrackSuccess(resp.json));
      } else {
        dispatch(onRequestReferralCoinTrackFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestReferralCoinTrackFailure(error.message));
    });
};

const ON_SAVE_REFERRAL_IMAGE = 'ON_SAVE_REFERRAL_IMAGE';

export const onSaveReferralPosterImage = base64Image => ({
    type: ON_SAVE_REFERRAL_IMAGE,
    payload: base64Image
  });

const INITIAL_STATE = {
  referralTrackerLoading: null,
  referralTrackerData: [],
  referralTrackerError: null,

  referralBonusInfoLoading: false,
  referralBonusInfoData: null,
  referralBonusInfoError: null,

  referralSendReminderLoading: [],

  referralBonusTransactionLoading: false,
  referralBonusTransactionData: null,
  referralBonusTransactionError: null,

  bonusListMFLoading: false,
  bonusListMFData: [],
  bonusListMFError: null,

  bonusListStockLoading: false,
  bonusListStockData: null,
  bonusListStockError: null,

  bonusListFeeLoading: false,
  bonusListFeeData: null,
  bonusListFeeError: null,

  referralLinkLoading: false,
  referralLinkData: null,
  referralLinkError: null,

  bonusSumStock: null,
  bonusSumStockLoading: false,
  bonusSumStockError: null,

  referredCoinTrack: null,
  referredCoinTrackLoading: false,
  referredCoinTrackError: null,

  referralPosterImage: null
};

const referral = (state = INITIAL_STATE, { type, payload, meta } = {}) => {
  const refTrackerId = parseInt(meta?.id?.referral_tracker_id, 10);
  switch (type) {
    case ON_REQUEST_REFERRAL_TRACKER:
      if (meta.resetData) {
        return {
          ...state,
          referralTrackerLoading: true,
          referralTrackerData: null,
          referralTrackerError: null,
        };
      } 
        return {
          ...state,
          referralTrackerLoading: true,
          referralTrackerError: null,
        };
      
    case ON_REQUEST_REFERRAL_TRACKER_SUCCESS:
      if (state.referralTrackerData) {
        const oldResults = [...state.referralTrackerData.results];
        state.referralTrackerData = {
          ...payload,
          next: payload.next,
          results: [...oldResults, ...payload.results],
        };
      } else {
        state.referralTrackerData = payload;
      }
      return {
        ...state,
        referralTrackerLoading: false,
        referralTrackerError: null,
      };
    case ON_REQUEST_REFERRAL_TRACKER_FAILURE:
      return {
        ...state,
        referralTrackerLoading: false,
        referralTrackerError: payload,
      };

    case ON_REQUEST_REFERRAL_SEND_REMINDER:
      if (state.referralSendReminderLoading.find(s => parseInt(s, 10) === refTrackerId)) {
        return state;
      }
      state.referralSendReminderLoading.push(refTrackerId);
      return {
        ...state,
        referralSendReminderLoading: [...state.referralSendReminderLoading],
      };
    case ON_REQUEST_REFERRAL_SEND_REMINDER_SUCCESS:
      if (state.referralSendReminderLoading.length > 0) {
        const idx = state.referralSendReminderLoading.findIndex(
          s => parseInt(s, 10) === refTrackerId
        );
        if (idx > -1) {
          state.referralSendReminderLoading.splice(idx, 1);
        }
      }
      return {
        ...state,
        referralTrackerData: state.referralTrackerData.map((s) => {
          if (parseInt(s.id, 10) === refTrackerId) {
            return {
              ...s,
              ...payload,
              can_remind: false,
            };
          }
          return s;
        }),
        referralSendReminderLoading: [...state.referralSendReminderLoading],
      };
    case ON_REQUEST_REFERRAL_SEND_REMINDER_FAILURE:
      if (state.referralSendReminderLoading.length > 0) {
        const idx = state.referralSendReminderLoading.findIndex(
          s => parseInt(s, 10) === refTrackerId
        );
        if (idx > -1) {
          state.referralSendReminderLoading.splice(idx, 1);
        }
      }
      return {
        ...state,
        referralSendReminderLoading: [...state.referralSendReminderLoading],
      };

    case ON_REQUEST_REFERRAL_BONUS_INFO:
      return {
        ...state,
        referralBonusInfoLoading: true,
        referralBonusInfoData: null,
        referralBonusInfoError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_INFO_SUCCESS:
      return {
        ...state,
        referralBonusInfoLoading: false,
        referralBonusInfoData: payload,
        referralBonusInfoError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_INFO_FAILURE:
      return {
        ...state,
        referralBonusInfoLoading: false,
        referralBonusInfoError: payload,
      };

    case ON_REQUEST_REFERRAL_BONUS_TRANSACTION:
      if (state.referralBonusInfoData) {
        state.referralBonusInfoData.referral_points -= 1;
      }
      return {
        ...state,
        referralBonusInfoData: {
          ...state.referralBonusInfoData,
        },
        referralBonusTransactionLoading: true,
        referralBonusTransactionData: null,
        referralBonusTransactionError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_TRANSACTION_SUCCESS:
      return {
        ...state,
        referralBonusTransactionLoading: false,
        referralBonusTransactionData: payload,
        referralBonusTransactionError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_TRANSACTION_FAILURE:
      return {
        ...state,
        referralBonusTransactionLoading: false,
        referralBonusTransactionError: payload,
      };

    case ON_REQUEST_REFERRAL_BONUS_LIST_MF:
      return {
        ...state,
        bonusListMFLoading: true,
        bonusListMFError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_LIST_MF_SUCCESS:
      return {
        ...state,
        bonusListMFLoading: false,
        bonusListMFData: payload,
        bonusListMFError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_LIST_MF_FAILURE:
      return {
        ...state,
        bonusListMFLoading: false,
        bonusListMFError: payload,
      };

    case ON_REQUEST_REFERRAL_BONUS_LIST_STOCK:
      if (meta.resetData) {
        state.bonusListStockData = null;
      }
      return {
        ...state,
        bonusListStockLoading: true,
        bonusListStockError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_LIST_STOCK_SUCCESS:
      if (state.bonusListStockData !== null) {
        state.bonusListStockData = {
          count: payload.count,
          results: [...state.bonusListStockData.results, ...payload.results],
        };
      } else {
        state.bonusListStockData = payload;
      }
      return {
        ...state,
        bonusListStockLoading: false,
        bonusListStockError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_LIST_STOCK_FAILURE:
      return {
        ...state,
        bonusListStockLoading: false,
        bonusListStockError: payload,
      };

    case ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE:
      return {
        ...state,
        bonusListFeeLoading: true,
        bonusListFeeError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE_SUCCESS:
      return {
        ...state,
        bonusListFeeLoading: false,
        bonusListFeeData: payload,
        bonusListFeeError: null,
      };
    case ON_REQUEST_REFERRAL_BONUS_LIST_FREE_FEE_FAILURE:
      return {
        ...state,
        bonusListFeeLoading: false,
        bonusListFeeError: payload,
      };

    case ON_REQUEST_REFERRAL_LINK:
      return {
        ...state,
        referralLinkLoading: true,
        referralLinkData: null,
        referralLinkError: null,
      };
    case ON_REQUEST_REFERRAL_LINK_SUCCESS:
      return {
        ...state,
        referralLinkLoading: false,
        referralLinkData: payload,
        referralLinkError: null,
      };
    case ON_REQUEST_REFERRAL_LINK_FAILURE:
      return {
        ...state,
        referralLinkLoading: false,
        referralLinkData: null,
        referralLinkError: payload,
      };

    case ON_REQUEST_BONUS_STOCK_SUMMARY:
      return {
        ...state,
        bonusSumStockLoading: true,
        bonusSumStockError: null,
        bonusSumStock: null,
      };
    case ON_REQUEST_BONUS_STOCK_SUMMARY_SUCCESS:
      return {
        ...state,
        bonusSumStockLoading: false,
        bonusSumStockError: null,
        bonusSumStock: payload,
      };
    case ON_REQUEST_BONUS_STOCK_SUMMARY_FAILURE:
      return {
        ...state,
        bonusSumStockLoading: false,
        bonusSumStockError: payload,
        bonusSumStock: null,
      };

    case ON_REQUEST_REFERRAL_COIN_TRACK:
      return {
        ...state,
        referredCoinTrackLoading: true,
        referredCoinTrackError: null,
        referredCoinTrack: null,
      };
    case ON_REQUEST_REFERRAL_COIN_TRACK_SUCCESS:
      return {
        ...state,
        referredCoinTrackLoading: false,
        referredCoinTrackError: null,
        referredCoinTrack: payload,
      };
    case ON_REQUEST_REFERRAL_COIN_TRACK_FAILURE:
      return {
        ...state,
        referredCoinTrackLoading: false,
        referredCoinTrackError: payload,
        referredCoinTrack: null,
      };
    case ON_SAVE_REFERRAL_IMAGE:
      return {
        ...state,
        referralPosterImage: payload
      };
    default:
      return state;
  }
};

export default referral;
